import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { REPORT_MIN_MATCHES, isReportUnlocked } from "../reportGate";
import ActiveBuyerReportComingSoonModal from "../../../components/Common/ActiveBuyerReportComingSoonModal";
import { downloadIconTwo } from "@/images";

export { REPORT_MIN_MATCHES };

// Temporary kill switch: force the coming-soon modal for every property,
// regardless of match count, until the report is ready to launch for real.
// Flip back to true to restore the normal unlock-at-REPORT_MIN_MATCHES gating.
const REPORT_ENABLED = false;

const BUTTON_STYLE = {
  marginTop: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 40,
  padding: 0,
  letterSpacing: "unset",
};

const ReportCTA = ({ inventoryId, totalMatches = 0, editMode = true }) => {
  const [showComingSoon, setShowComingSoon] = useState(false);
  const unlocked = REPORT_ENABLED && isReportUnlocked(totalMatches);

  // Reset the coming-soon modal when the selected property changes, so it
  // doesn't stay open (referencing the old property) if left open while
  // switching properties.
  useEffect(() => {
    setShowComingSoon(false);
  }, [inventoryId]);

  const openReport = () => {
    if (!inventoryId) return;
    const url = editMode
      ? `/reports/active-buyer/${inventoryId}?edit=1`
      : `/reports/active-buyer/${inventoryId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Button
        className="btn-grey w-100"
        data-tour="download-report-match"
        onClick={unlocked ? openReport : () => setShowComingSoon(true)}
        style={BUTTON_STYLE}
      >
        Download Report
        <img
          src={downloadIconTwo}
          style={{ width: 12, height: 12, marginLeft: 8 }}
          alt=""
        />
      </Button>
      {!unlocked && (
        <ActiveBuyerReportComingSoonModal
          show={showComingSoon}
          onHide={() => setShowComingSoon(false)}
        />
      )}
    </>
  );
};

export default ReportCTA;
